import KatalLogger from '@amzn/katal-logger';
import { NodeEnv } from 'src/constants';

export const logger = new KatalLogger({
  url:
    process.env.NODE_ENV === NodeEnv.production
      ? 'https://74tfwtmc7l.execute-api.eu-west-1.amazonaws.com/prod/v1/log'
      : undefined,
  maxLogLineSize: 10000, // default 5000
});
